/**
 * AutoSaveIndicator - 自动保存状态指示器
 * 显示当前的自动保存状态
 */

import React from 'react';
import { AutoSaveStatus } from '../../hooks/useAutoSave';
import './DraftRecoveryModal.css';

const AutoSaveIndicator = ({ status, lastSavedTime, error, onClick }) => {
  const getStatusConfig = () => {
    switch (status) {
      case AutoSaveStatus.SAVING:
        return {
          className: 'autosave-indicator--saving',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
            </svg>
          ),
          text: '保存中...',
        };
      case AutoSaveStatus.SAVED:
        return {
          className: 'autosave-indicator--saved',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          ),
          text: lastSavedTime || '已保存',
        };
      case AutoSaveStatus.ERROR:
        return {
          className: 'autosave-indicator--error',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
          ),
          text: '保存失败',
          tooltip: error,
        };
      case AutoSaveStatus.CHANGED:
        return {
          className: 'autosave-indicator--changed',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          ),
          text: '未保存',
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  return (
    <div
      className={`autosave-indicator ${config.className}`}
      title={config.tooltip || config.text}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {config.icon}
      <span>{config.text}</span>
    </div>
  );
};

export default AutoSaveIndicator;
